// extracted by mini-css-extract-plugin
export default {"list":"FeaturesSection_list__BGUQo","item":"FeaturesSection_item__gn1G2","check":"FeaturesSection_check__9VodG"};